const COLLAPSE_KEY = 'bunker.heroCollapsedCategories.v1';

/** The set of collapsed category ids for the channel sidebar, persisted to
 *  localStorage per device. Corrupt / missing storage degrades to an empty
 *  set (nothing collapsed). */
export function loadCollapsed(): Set<string> {
  try {
    const raw = localStorage.getItem(COLLAPSE_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

export function saveCollapsed(set: Set<string>) {
  try {
    localStorage.setItem(COLLAPSE_KEY, JSON.stringify([...set]));
  } catch {
    /* private mode — in-memory only */
  }
}
